export const DOKA_360_PRODUCT_URL = 'https://www.doka.com/doka360';
